// extracted by mini-css-extract-plugin
export default {"header":"UserGroup_header__-6dhD","rolesContainer":"UserGroup_rolesContainer__UYogx","roleLabel":"UserGroup_roleLabel__MbRWU","roleActions":"UserGroup_roleActions__nlzaW"};